import {
    Mesh,
    Scene,
    Shape,
    ExtrudeGeometry,
    MeshStandardMaterial,
    Vector3,
    LineCurve3,
    Group,
    Object3D,
    BoxGeometry
  } from 'three';
  
  import PoolBorders from './pool_borders';
  
  class InfinityBorders {
    private infinityMesh: Object3D;
    private infinityGround: Mesh;
    private poolBorders: PoolBorders;
    outlineSize: number;
  
    private material: MeshStandardMaterial;
  
    constructor(poolBorders: PoolBorders, outlineSize: number = 0.5) {
      this.poolBorders = poolBorders;
      this.outlineSize = outlineSize;
  
      this.material = new MeshStandardMaterial({
        color: '#354349',
        roughness: 1,
        metalness: 0.2,
        wireframe:false 
      });
  
      this.createRectangularPath();
    }
  
    addToScene(scene: Scene) {
      scene.add(this.infinityMesh);
    }
  
    removeFromScene(scene: Scene) {
      scene.remove(this.infinityMesh);
    }
  
    private createRectangularPath() {
      const group = new Group();
      const quadSize = 0.08;
  
      const fullLength = this.poolBorders.poolLength  + this.poolBorders.margin * 2.0 + this.outlineSize ;
      const fullWidth = this.poolBorders.poolWidth  + this.poolBorders.margin * 2.0 + this.outlineSize ;
  
      // Dimensions for the boxes representing each side of the rectangle
      const sideDimensions = [
          { width: quadSize, height: quadSize, depth: fullWidth + quadSize}, // Top and bottom sides
          { width: fullLength, height: quadSize, depth: quadSize }   // Left and right sides
      ];
  
      for (let i = 0; i < 4; i++) {
          const { width, height, depth } = sideDimensions[i < 2 ? 0 : 1];
          const geometry = new BoxGeometry(width, height, depth);
          const mesh = new Mesh(geometry, this.material);
  
          if (i < 2) {
           mesh.position.set(i === 0 ? -fullLength/2.0 : fullLength/2.0, 0, 0);
              
          } else {
            mesh.position.set(0, 0, i === 2 ? -fullWidth/2.0 : fullWidth/2.0);
              
          }
  
          mesh.castShadow = true;
          mesh.receiveShadow = true;
          group.add(mesh);
      }
  
      group.translateY(-0.02);
  
      this.infinityMesh = group;
  }

        resize(scene: Scene) {
            this.removeFromScene(scene);
            this.createRectangularPath();
            this.addToScene(scene);
        }
  }
  
  export default InfinityBorders;
  